import { Widget } from "./angular2-schema-form-shim";
import { getWidgetType, isWidgetRequired } from "./widgets/overrides";
var WidgetValidationError = (function () {
    function WidgetValidationError() {
        this.errors = [];
    }
    Object.defineProperty(WidgetValidationError.prototype, "hasErrors", {
        get: function () {
            return this.errors && this.errors.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetValidationError.prototype, "required", {
        get: function () {
            return isWidgetRequired(this.widget);
        },
        enumerable: true,
        configurable: true
    });
    WidgetValidationError.prototype.errorIdentity = function (index, message) {
        return message;
    };
    Object.defineProperty(WidgetValidationError.prototype, "uniqueMessages", {
        get: function () {
            var seen = new Set();
            var result = [];
            for (var _i = 0, _a = this.errors; _i < _a.length; _i++) {
                var error = _a[_i];
                var message = this.niceMessage(error);
                if (!seen.has(message)) {
                    seen.add(message);
                    result.push(message);
                }
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    WidgetValidationError.prototype.niceMessage = function (error) {
        var isSelect = this.widget && getWidgetType(this.widget) === 'select';
        switch (error.code) {
            case 'PROPERTY_VALUE_REQUIRED':
                return isSelect ? 'Please select an option' : 'This field is required';
            case 'INVALID_TYPE':
            case 'ENUM_MISMATCH':
                if (isSelect)
                    return 'Please select an option';
                return error.message;
            default: return error.message;
        }
    };
    return WidgetValidationError;
}());
export { WidgetValidationError };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/error.component.ts.pre-build-optimizer.js